import { render, staticRenderFns } from "./PageParents.vue?vue&type=template&id=2dac40d5&scoped=true&"
import script from "./PageParents.vue?vue&type=script&lang=js&"
export * from "./PageParents.vue?vue&type=script&lang=js&"
import style0 from "./PageParents.vue?vue&type=style&index=0&id=2dac40d5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dac40d5",
  null
  
)

export default component.exports